var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes },
    [
      _c(
        "div",
        { staticClass: "banner__inner" },
        [
          _c("vue-client-only", [
            _c(
              "a",
              {
                staticClass: "banner__link",
                attrs: {
                  href: _vm.getBannerData(_vm.data, ["body", "url"]),
                  target: _vm.getBannerData(_vm.data, ["body", "target"])
                },
                on: {
                  click: function($event) {
                    return _vm.onClick()
                  }
                }
              },
              [
                _vm.backAsImg
                  ? _c("img", {
                      staticClass: "banner__backgound-img",
                      attrs: {
                        src: _vm.getBannerData(_vm.data, ["body", "image"]),
                        alt: _vm.getBannerData(_vm.data, ["body", "alt"])
                      }
                    })
                  : _c("div", {
                      staticClass: "banner__background",
                      style:
                        "background-image: url(" +
                        _vm.getBannerData(_vm.data, ["body", "image"]) +
                        ")"
                    }),
                _vm.getBannerData(_vm.data, ["body", "svg"])
                  ? _c("div", { staticClass: "banner__top" }, [
                      _c("div", {
                        staticClass: "banner__foreground",
                        style:
                          "background-image: url(" +
                          _vm.getBannerData(_vm.data, ["body", "svg"]) +
                          ")"
                      })
                    ])
                  : _vm._e()
              ]
            )
          ])
        ],
        1
      ),
      _c("vue-client-only", [
        _vm.getBannerData(_vm.data, ["links", "length"])
          ? _c(
              "div",
              { class: _vm.linksClasses(_vm.data) },
              _vm._l(_vm.getBannerData(_vm.data, ["links"]), function(link) {
                return _c(
                  "a",
                  {
                    key: link.text,
                    staticClass: "banner__links-item",
                    style: _vm.fontStyles(link),
                    attrs: { href: link.url },
                    on: {
                      click: function($event) {
                        return _vm.onClick(link)
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(link.text) + "\n      ")]
                )
              }),
              0
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }